/*=========================================================================================
  File Name: moduleEmailActions.js
  Description: Email Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getCategories({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/technical/sparepart/category")
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  storeCategory({ commit }, paylaod) {
    return new Promise((resolve, reject) => {
      axios
        .post("/technical/sparepart/category", paylaod)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/technical/sparepart/category/${payload.id}`, payload.body)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteCategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/technical/sparepart/category/${id}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
